import { useTranslation } from "react-i18next";

export const useConceptoTipoUsuarioMovil = () => {
    const { t } = useTranslation();
    const CONCEPTO_TIPO_USUARIO_MOVIL = [
        { value: 7, label: t("label_tranportadora_sindicato") },
        { value: 8, label: t("label_usuario_singular") },
    ];
    return CONCEPTO_TIPO_USUARIO_MOVIL;
};
